<template>
  <div class="comission-grid-view">
    <div class="toolbar">
      <v-btn icon @click="$emit('prev-month')"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <slot name="month" />
      <v-btn icon @click="$emit('next-month')"><v-icon>mdi-chevron-right</v-icon></v-btn>
      <v-divider vertical class="mx-2" />
      <v-btn
        v-if="editing"
        outlined
        color="primary"
        small
        :loading="copying"
        @click="$emit('copy-month')"
      >
        <v-icon left small>mdi-content-copy</v-icon>
        Copiar do mês anterior
      </v-btn>
      <v-btn
        outlined
        color="primary"
        small
        @click="$emit('add-seller')"
      >
        <v-icon left small>mdi-account-plus</v-icon>
        Adicionar
      </v-btn>
      <v-spacer />
      <v-text-field
        :value="search"
        dense
        hide-details
        clearable
        prepend-inner-icon="mdi-magnify"
        placeholder="Pesquise.."
        style="max-width: 260px"
        @input="$emit('update:search', $event)"
      />
    </div>

    <div class="comission-grid-scroll" :class="{ 'is-readonly': !editing }">
      <table class="comission-grid">
        <thead>
          <tr class="group-row">
            <th rowspan="2" class="sticky-col">Vendedor</th>
            <th colspan="2">Comissão Cimento</th>
            <th colspan="3">Fixas (R$)</th>
            <th colspan="4">Comissão Lucratividade (R$)</th>
            <th colspan="3">Metas Volume (R$)</th>
            <th colspan="4">Metas Cliente (R$)</th>
            <th colspan="3">Metas Lucro (R$)</th>
            <th colspan="2">Bônus (R$)</th>
          </tr>
          <tr class="sub-row">
            <th v-for="h in subHeaders" :key="h">{{ h }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in filteredRows" :key="row.employee_id">
            <td class="sticky-col seller-name">
              <div class="seller-cell">
                <span>{{ row.employee_name }}</span>
                <v-btn icon x-small class="remove-btn" @click="$emit('remove-seller', row)">
                  <v-icon x-small>mdi-close</v-icon>
                </v-btn>
              </div>
            </td>
            <td>
              <select
                v-model="row.cement_comission_type"
                class="cell-select"
                :disabled="!editing"
                @change="markDirty(row)"
              >
                <option value="per_bag">Por saco (R$)</option>
                <option value="per_revenue">Por faturamento (%)</option>
              </select>
            </td>
            <td><input v-model.number="row.cement_fixed_comission" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.fassa_fixed_comission" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.other_products_fixed_comission" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.yard_cal_fixed_comission" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profitability_bonus" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profitability_margin_increase" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profitability_yard_margin" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profitability_gc_margin" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.volume_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.volume_super_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.volume_hyper_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td>
              <select
                v-model="row.client_goal_type"
                class="cell-select"
                :disabled="!editing"
                @change="markDirty(row)"
              >
                <option value="fixed">Fixo</option>
                <option value="variable">Variável</option>
              </select>
            </td>
            <td><input v-model.number="row.client_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.client_super_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.client_hyper_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profit_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profit_super_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.profit_hyper_goal" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.reactivated_clients_bonus" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
            <td><input v-model.number="row.new_clients_bonus" class="cell-input" type="number" step="any" :readonly="!editing" @input="markDirty(row)" /></td>
          </tr>
          <tr v-if="!filteredRows.length">
            <td colspan="22" class="pa-6 grey--text">Nenhum vendedor encontrado</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer-bar d-flex align-center pa-3">
      <div class="caption grey--text">
        {{ filteredRows.length }} vendedores · valores de {{ monthLabel }}
        <span v-if="editing && dirtyCount" class="orange--text ml-2">· {{ dirtyCount }} alteração(ões)</span>
      </div>
      <v-spacer />
      <template v-if="editing">
        <f-btn cancel class="mr-2" :disabled="saving" @click="$emit('cancel-edit')" />
        <f-btn save :disabled="!dirtyCount || saving" :loading="saving" @click="$emit('save-all')" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellerComissionGridView',
  props: {
    rows: { type: Array, required: true },
    search: { type: String, default: '' },
    monthLabel: { type: String, required: true },
    editing: { type: Boolean, default: false },
    copying: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      subHeaders: [
        'Tipo Comissão Cimento', 'Comissão Fixa Cimento', 'Marca Fassa', 'Outros Produtos', 'Cal Galpão',
        'Bônus', 'Aumento de Margem', 'Margem Galpão', 'Margem GC',
        'Meta Volume', 'Super Meta Volume', 'Hiper Meta Volume',
        'Tipo Meta Cliente', 'Meta Cliente', 'Super Meta Cliente', 'Hiper Meta Cliente',
        'Meta Lucro', 'Super Meta Lucro', 'Hiper Meta Lucro',
        'Clientes Reativados', 'Novos Clientes',
      ],
    }
  },
  computed: {
    filteredRows() {
      const q = (this.search || '').toLowerCase().trim()
      if (!q) return this.rows
      return this.rows.filter((r) => (r.employee_name || '').toLowerCase().includes(q))
    },
    dirtyCount() {
      return this.rows.filter((r) => r._dirty).length
    },
  },
  methods: {
    markDirty(row) {
      if (!this.editing) return
      row._dirty = true
      this.$emit('dirty')
    },
  },
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 9px 16px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}
.comission-grid-scroll {
  overflow: auto;
  max-height: calc(100vh - 320px);
}
.comission-grid {
  border-collapse: collapse;
  min-width: 2280px;
  width: 100%;
  font-size: 12px;
}
.comission-grid th,
.comission-grid td {
  border: 1px solid #e0e0e0;
  padding: 4px 6px;
  text-align: center;
  white-space: nowrap;
}
.comission-grid .group-row th {
  background: #f5f5f5;
  color: #455a64;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.3px;
}
.comission-grid .sub-row th {
  background: #fafafa;
  color: #90a4ae;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
}
.sticky-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
  text-align: left !important;
  min-width: 200px;
  max-width: 240px;
}
thead .sticky-col {
  z-index: 3;
  background: #f5f5f5;
}
.seller-name {
  font-weight: 500;
  color: #37474f;
}
.seller-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.seller-cell span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
}
.remove-btn {
  flex: none;
  margin-left: auto;
  opacity: 0.45;
}
.remove-btn:hover {
  opacity: 1;
}
.cell-input,
.cell-select {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
  font-size: 12px;
  padding: 4px 2px;
  color: #263238;
}
.cell-input:focus,
.cell-select:focus {
  background: #e3f2fd;
}
.is-readonly .cell-input,
.is-readonly .cell-select {
  background: #fafafa;
  color: #607d8b;
  cursor: default;
}
.cell-input::-webkit-outer-spin-button,
.cell-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.cell-input[type='number'] {
  -moz-appearance: textfield;
}
.footer-bar {
  border-top: 1px solid #e0e0e0;
  background: #fff;
}
</style>
